/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
/* eslint-disable max-len */
import { ActionRuleParams } from '../../types';
import { formatValidation, getIslandLetter } from '../island-validation-format';
import { libLang } from '../../../../lang'
import { nearestSixteenth } from '../../../../helpers';
import { NotificationType } from '../../../notifications/enums';
// import { usePanel } from '@rta/rta-blueprint-component'
type Intersects = {
	id: string;
	itemRefId: string;
	item: string;
	iDescription: string;
	pLabel: string;
	size: number;
	limit: number;
}

export const countertopSpacing = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { islands } = refMap.kitchen.design
	const { notifications } = refMap.kitchen.design
	const minDistanceSGrills = 7;
	const minDistanceFromEdge = 5;
	const minDistanceFromBackPanel = 1.5;
	const minDistanceFromApps = 4.5;
	const badIntersects: Intersects[] = [];
	const sGrills: Record<string, string> = {};
	const outlets: Record<string, string> = {};
	const standAlone: Record<string, string> = {};
	const allItems: Record<string, string> = {};


	const sSeriesGrills = ['C3SL30', 'C3SL36', 'C3SL42', 'C3JAKTCSL30', 'C2SL30', 'C2SL36']
	// notifications.purgeReferences(libLang.validations.island.panel.spacing);

	if (!islands) return

	islands.children.forEach((island) => {
		const countertopPanel = island.panels.getFrontPanel();
		if (!countertopPanel.refMap.island.getCountertop()) return
		const overhangs = island.getOverhangs();
		const baseHorizontalIntersects = countertopPanel.getHorizontalIntersectionAreas({ inside: true, includeDuplicates: false, includeEnd2End: false, minHeight: 0.5, isCountertop: true })
			.map((area) => ({
				...area,
				shouldHide: false
				// dimension: kitchen.design.dimensions.find(area.InterectionReferenceIds, area.axis, true) as Dimension
			}));

		const baseVerticalIntersects = countertopPanel.getVerticalIntersectionAreas({ inside: true, includeDuplicates: false, includeEnd2End: false, minWidth: 0.5, isCountertop: true })
			.map((area) => ({
				...area,
				shouldHide: false
				// dimension: kitchen.design.dimensions.find(area.InterectionReferenceIds, area.axis, true) as Dimension
			}));

		// getHorizontalIntersectionAreas/getVerticalIntersectionAreas with isCountertop:true walk every panel on
		// the island (not just countertopPanel), so this lookup must too or back/side-panel items resolve to undefined below.
		island.panels.children.flatMap((panel) => panel.panelItemGroups.children).forEach((group) => {
			group.items.children.forEach((item) => {
				if (sSeriesGrills.includes(item.item.sku)) {
					sGrills[item.id] = item.item.sku
				} else if (item.item.sku === 'LEF-OB-2-CT-SP' || item.item.sku.startsWith('CUSTOM_UMBRELLA_CT-') || item.item.sku.startsWith('CUSTOM_GASOLINE_CT-') || item.item.sku === 'GAS_LINE_CUTOUT') {
					outlets[item.id] = item.item.sku
				}
				if (item.item.category?.description === 'Pizza Ovens' || item.item.sku === 'C1CHCS') standAlone[item.id] = item.item.sku

				allItems[item.id] = item.item.sku
			})
		})

		// console.log('appliance:obj', sGrills);

		const panelEdge = countertopPanel.id;
		if (panelEdge && baseHorizontalIntersects && baseVerticalIntersects) {
			baseHorizontalIntersects.forEach((hi) => {
				const width = nearestSixteenth(hi.size.width);
				const [firstId] = hi.intersectionReferenceIds;
				const [, secondId] = hi.intersectionReferenceIds;
				const currentItemId = firstId === panelEdge ? secondId : firstId;
				const currentItem = allItems[currentItemId];

				// Ignore pizza ovens from edges (still applies to interappliance spacing)
				if ((firstId in standAlone && secondId === panelEdge) || (secondId in standAlone && firstId === panelEdge)) return

				// edges |--A--| else if b/w apps |-X-A--A--A-x-|
				if (width < minDistanceFromApps && width > 0 && ((!hi.intersectionReferenceIds.includes(panelEdge)))) {
					badIntersects.push({
						id: panelEdge,
						itemRefId: currentItemId,
						item: currentItem,
						iDescription: island.description,
						pLabel: countertopPanel.label,
						size: width,
						limit: minDistanceFromApps
					})
				} else if ((hi.intersectionReferenceIds.includes(panelEdge) && width < minDistanceFromEdge) && width > 0) {
					badIntersects.push({
						id: panelEdge,
						itemRefId: currentItemId,
						item: currentItem,
						iDescription: island.description,
						pLabel: countertopPanel.label,
						size: width,
						limit: minDistanceFromEdge
					})
				}
				// S-Series Grill rotisserie spacing
				if (width < minDistanceSGrills && width > 0 && ((firstId in sGrills) || (secondId in sGrills))) {
					// console.log('grill:rule');
					badIntersects.push({
						id: panelEdge,
						itemRefId: currentItemId,
						item: currentItem,
						iDescription: island.description,
						pLabel: countertopPanel.label,
						size: width,
						limit: minDistanceSGrills
					})
				}
				// Pop-up outlet spacing
				if (width < minDistanceFromEdge && width > 0 && ((firstId in outlets) || (secondId in outlets))) {
					// console.log('popup:rule');
					badIntersects.push({
						id: panelEdge,
						itemRefId: currentItemId,
						item: currentItem,
						iDescription: island.description,
						pLabel: countertopPanel.label,
						size: width,
						limit: minDistanceFromEdge
					})
				}
			})
			baseVerticalIntersects.forEach((vi) => {
				let height = nearestSixteenth(vi.size.height);
				const [firstId] = vi.intersectionReferenceIds;
				const [, secondId] = vi.intersectionReferenceIds;
				const currentItemId = firstId === panelEdge ? secondId : firstId;
				const currentItem = allItems[currentItemId];
				if ((firstId === panelEdge) && (height - overhangs.front) < minDistanceFromBackPanel) {
					height -= (overhangs.front + countertopPanel.thickness);
					badIntersects.push({
						id: panelEdge,
						itemRefId: currentItemId,
						item: currentItem,
						iDescription: island.description,
						pLabel: countertopPanel.label,
						size: nearestSixteenth(height),
						limit: (!vi.intersectionReferenceIds.includes(panelEdge) && height < minDistanceFromApps) ? minDistanceFromApps : minDistanceFromBackPanel
					})
				} else if ((secondId === panelEdge) && (height - overhangs.back) < minDistanceFromBackPanel) {
					height -= (overhangs.back + countertopPanel.thickness);
					badIntersects.push({
						id: panelEdge,
						itemRefId: currentItemId,
						item: currentItem,
						iDescription: island.description,
						pLabel: countertopPanel.label,
						size: nearestSixteenth(height),
						limit: (!vi.intersectionReferenceIds.includes(panelEdge) && height < minDistanceFromApps) ? minDistanceFromApps : minDistanceFromBackPanel
					})
				}
			})
		}
		// console.log('horizontalIntersects', baseHorizontalIntersects, 'verticalIntersects', baseVerticalIntersects, 'panelEdge', panelEdge);
	})
	// console.log('badIntersects', refMap)
	badIntersects.forEach((bi) => {
		const island = islands.children.find((isl) => isl.panels.children.some((p) => p.id === bi.id));
		notifications.add({
			refId: bi.id,
			itemRefId: bi.itemRefId,
			validationCode: libLang.validations.island.panel.spacing,
			description: formatValidation({ letter: island ? getIslandLetter(island) : '', islandDescription: bi.iDescription, location: `${bi.pLabel} countertop`, issue: `${bi.item ?? 'Item'} needs more spacing — current ${bi.size}", minimum ${bi.limit}"` }),
			type: NotificationType.Warn
		})
	})
}
